import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../../app/hooks";

function ReportedByDetails() {
  const variance = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );

  return (
    <React.Fragment>
      <Card sx={{ borderRadius: "10px", marginBottom: "10px" }}>
        <CardHeader
          sx={{
            marginBottom: "0px",
            paddingBottom: "3px",
            paddingTop: "3px",
            borderBottom: "solid",
            borderColor: "gray",
          }}
          title={
            <Typography variant="h6" color="gray">
              Reported by
            </Typography>
          }
        />
        <CardContent>
          <Stack direction="column" gap={2}>
            <TextField
              disabled
              name="createdBy"
              label="Created By"
              value={variance.createdBy || ""}
              size="small"
              InputLabelProps={{ shrink: true }}
            />              <TextField
                disabled
                name="VarianceStartDate"
                label="Report Date"
                value={variance.varianceStartDate ? new Date(variance.varianceStartDate).toLocaleDateString() : ""}
                size="small"
                InputLabelProps={{ shrink: true }}
              />
          </Stack>
        </CardContent>
      </Card>
    </React.Fragment>
  );
}

export { ReportedByDetails };
